import { Button } from '@codeparva/ui-components-library';
import React from 'react';
import { PayRentTypes } from '../../PayRentTypes';
import { Icon } from '../../../../utilities/icomoon-css';
import { successScreenLabels } from '../../constants/accountPanelConfigs';
import {
  SectionCardTitle,
  SectionContentSubTitle,
  Text,
} from '../../../../components/textVariations';

export const SuccessScreen = ({
  tenantMail,
  paidAmount,
  authCode,
  balanceDue,
  clickHandler,
}: PayRentTypes.TSuccessScreen) => {
  const { email_address = '' } = tenantMail;
  const {
    amountLabel,
    authLabel,
    buttonLabel,
    currBalanceLabel,
    mainLabel,
    paymentMessage,
  } = successScreenLabels;
  return (
    <div
      className="successPaymentContainer"
      data-testid="payment-complete-card"
    >
      <div className="successIconContainer" data-testid="payment-success-icon">
        <Icon name="tfw-tick-circle-2-cp" size={47}></Icon>
      </div>
      <div className="successGreeting">
        <SectionCardTitle>{mainLabel}</SectionCardTitle>
      </div>
      <div className="thankingMessage" data-testid="thank-you-message">
        <Text>
          {paymentMessage}: {email_address}
        </Text>
      </div>
      <div className="billingDetailsContainer">
        <div className="billingDetailsItem" data-testid="payment-amount">
          <Text>{amountLabel}</Text>
          <div>
            <SectionContentSubTitle>${paidAmount}</SectionContentSubTitle>
          </div>
        </div>
        {authCode && (
          <div className="billingDetailsItem" data-testid="payment-auth-code">
            <Text>{authLabel}</Text>
            <div>
              <SectionContentSubTitle> {authCode}</SectionContentSubTitle>
            </div>
          </div>
        )}
        <div className="billingDetailsItem" data-testid="current-balance-due">
          <Text>{currBalanceLabel}</Text>
          <SectionContentSubTitle>${balanceDue}</SectionContentSubTitle>
        </div>
        <div className="buttonContainer">
          <Button
            className="payAgainButton"
            onClick={clickHandler}
            data-testid="pay-again-btn"
          >
            <Text>{buttonLabel}</Text>
          </Button>
        </div>
      </div>
    </div>
  );
};
